import { render, staticRenderFns } from "./ActivityImage.vue?vue&type=template&id=039ffe13&scoped=true"
import script from "./ActivityImage.vue?vue&type=script&lang=js"
export * from "./ActivityImage.vue?vue&type=script&lang=js"
import style0 from "./ActivityImage.vue?vue&type=style&index=0&id=039ffe13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ffe13",
  null
  
)

export default component.exports